import { Card, Radio, Row, Col, Space, Statistic, Form, Divider } from "antd";
import { BASE_COLORS } from "config/theme/constants";
import TimeFrameComponent from "components/common/TimeFrameComponent";
import { formatFloatingNumber } from "utils/utils";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  MailOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { DashboardFilterWrapper } from "./styles";

const MetricCard = ({ children }: any) => (
  <Card
    style={{
      height: "100%",
      boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      borderColor: "rgb(0 0 0 / 0.1)",
    }}
  >
    {children}
  </Card>
);

const LabelColCard = ({ labelName }: any) => (
  <Col
    span={24}
    style={{
      paddingBottom: 10,
    }}
  >
    <label
      style={{
        fontSize: 14,
        fontWeight: 600,
        color: "#000000",
        paddingBottom: 10,
      }}
    >
      {labelName}
    </label>
  </Col>
);

const commonIconStyle = {
  fontSize: 14,
  color: BASE_COLORS.grayShade,
  marginRight: 8,
};

const CustomStatistic = (
  IconComponent: any,
  label: string,
  StatisticComponent: any
) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {IconComponent}
      <div style={{ display: "flex", alignItems: "center" }}>
        <span
          style={{
            marginRight: 8,
            color: BASE_COLORS.grayShade,
            fontWeight: 500,
            fontSize: 14,
          }}
        >
          {label}:
        </span>
        {StatisticComponent}
      </div>
    </div>
  );
};

const DashboardFilters = ({
  selectedDateRange,
  onChange,
  label,
  handleCustomDateChange,
  handleDateRangeChange,
  activityAvgDetailsState,
  form,
  showMetrics = true,
}: any) => {
  const overallSuccessRate: any = (
    (activityAvgDetailsState?.success /
      activityAvgDetailsState?.activityCount) *
    100
  )?.toFixed(2);
  const overallPodSuccessRate = 
  (activityAvgDetailsState?.success / activityAvgDetailsState?.activityCount) * 100;
  const mlSuccessRate: any = (
    (activityAvgDetailsState?.mlSuccessCounts /
      activityAvgDetailsState?.activityCount) *
    100
  )?.toFixed(2);
  const tmsSuccessRate: any = (
    ((activityAvgDetailsState?.tmsSuccessCounts +
      activityAvgDetailsState?.tmsResolvedCounts) /
      activityAvgDetailsState?.activityCount) *
    100
  )?.toFixed(2);

  return (
    <DashboardFilterWrapper>
      <Form form={form} layout="vertical">
        <div style={{ marginBottom: 24, marginTop: 30 }}>
          <TimeFrameComponent
            selectedDateRange={selectedDateRange}
            handleDateRangeChange={handleDateRangeChange}
            handleCustomDateChange={handleCustomDateChange}
          />
        </div>

        {showMetrics ? (
        <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
          <Col xs={24} xl={10}>
            <MetricCard>
              <Row>
                <LabelColCard labelName="Overall Status" />
                <Col span={24}>
                  <Row>
                    <Col span={11}>
                      <Row>
                        <Col span={24}>
                          {CustomStatistic(
                            <CheckCircleOutlined style={commonIconStyle} />,
                            "Success",
                            <Statistic
                              value={activityAvgDetailsState?.success}
                              valueStyle={{
                                display: "inline",
                                color: "#4caf50",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <CloseCircleOutlined style={commonIconStyle} />,
                            "Failed",
                            <Statistic
                              value={activityAvgDetailsState?.failed}
                              valueStyle={{
                                display: "inline",
                                color: "#F44336",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <ClockCircleOutlined style={commonIconStyle} />,
                            "In Queue",
                            <Statistic
                              value={activityAvgDetailsState?.queueCounts}
                              valueStyle={{
                                display: "inline",
                                color: "#D4831c",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <CheckCircleOutlined style={commonIconStyle} />,
                            "Success Rate",
                            <Statistic
                              value={
                                !isNaN(overallSuccessRate)
                                  ? formatFloatingNumber(overallSuccessRate)
                                  : 0
                              }
                              valueStyle={{
                                display: "inline",
                                color: "#4caf50",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                              suffix="%"
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={1}>
                      <Divider
                        type="vertical"
                        style={{
                          height: "100%",
                          marginLeft: 0,
                          borderColor: "rgb(0 0 0 / 0.1)",
                        }}
                      />
                    </Col>
                    <Col span={12}>
                      <Row>
                        <Col span={24}>
                          {CustomStatistic(
                            <MailOutlined style={commonIconStyle} />,
                            "Emails",
                            <Statistic
                              value={activityAvgDetailsState?.emailCounts}
                              valueStyle={{
                                display: "inline",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <LinkOutlined style={commonIconStyle} />,
                            "Attachments",
                            <Statistic
                              value={activityAvgDetailsState?.totalAttachments}
                              valueStyle={{
                                display: "inline",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <LinkOutlined style={commonIconStyle} />,
                            label === "Customer" ? "Orders" : "Invoices",
                            <Statistic
                              value={activityAvgDetailsState?.activityCount}
                              valueStyle={{
                                display: "inline",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                         <Col span={24}>
                          {CustomStatistic(
                            <LinkOutlined style={commonIconStyle} />,
                            "Invalid",
                            <Statistic
                              value={activityAvgDetailsState?.invalidCounts}
                              valueStyle={{
                                display: "inline",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <ClockCircleOutlined style={commonIconStyle} />,
                            "Avg. Total Time",
                            <Statistic
                              value={
                                activityAvgDetailsState?.avgEmailsProcessingTime ||
                                0
                              }
                              valueStyle={{
                                display: "inline",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                              suffix="sec"
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </MetricCard>
          </Col>
          <Col xs={24} xl={7}>
            <MetricCard>
              <LabelColCard labelName="ML Status" />
              <Col span={24}>
                {CustomStatistic(
                  <CheckCircleOutlined style={commonIconStyle} />,
                  "ML Success",
                  <Statistic
                    value={!isNaN(mlSuccessRate) ? formatFloatingNumber(mlSuccessRate) : 0}
                    suffix="%"
                    valueStyle={{
                      display: "inline",
                      color: "#4caf50",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
              <Col span={24}>
                {CustomStatistic(
                  <CheckCircleOutlined style={commonIconStyle} />,
                  "Success",
                  <Statistic
                    value={activityAvgDetailsState?.mlSuccessCounts}
                    valueStyle={{
                      display: "inline",
                      color: "#4caf50",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
              <Col span={24}>
                {CustomStatistic(
                  <CloseCircleOutlined style={commonIconStyle} />,
                  "Failed",
                  <Statistic
                    value={activityAvgDetailsState?.mlFailedCounts}
                    valueStyle={{
                      display: "inline",
                      color: "#F44336",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
              <Col span={24}>
                {CustomStatistic(
                  <ClockCircleOutlined style={commonIconStyle} />,
                  "Avg. ML Time",
                  <Statistic
                    value={activityAvgDetailsState?.avgMlProcessingTime || 0}
                    suffix="sec"
                    valueStyle={{
                      display: "inline",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
            </MetricCard>
          </Col>
          <Col xs={24} xl={7}>
            <MetricCard>
              <LabelColCard labelName="TMS Status" />
              <Col span={24}>
                {CustomStatistic(
                  <CheckCircleOutlined style={commonIconStyle} />,
                  "TMS Success",
                  <Statistic
                    value={!isNaN(tmsSuccessRate) ? formatFloatingNumber(tmsSuccessRate) : 0}
                    suffix="%"
                    valueStyle={{
                      display: "inline",
                      color: "#4caf50",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
              <Col span={24}>
                {CustomStatistic(
                  <CheckCircleOutlined style={commonIconStyle} />,
                  "Success",
                  <Statistic
                    value={activityAvgDetailsState?.tmsSuccessCounts}
                    valueStyle={{
                      display: "inline",
                      color: "#4caf50",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
              <Col span={12}>
                {CustomStatistic(
                  <CloseCircleOutlined style={commonIconStyle} />,
                  "Failed",
                  <Statistic
                    value={activityAvgDetailsState?.tmsFailedCounts}
                    valueStyle={{
                      display: "inline",
                      color: "#F44336",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
              <Col span={12}>
                {CustomStatistic(
                  <ClockCircleOutlined style={commonIconStyle} />,
                  "Resolved",
                  <Statistic
                    value={activityAvgDetailsState?.tmsResolvedCounts}
                    valueStyle={{
                      display: "inline",
                      color: "#D4831c",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
              <Col span={24}>
                {CustomStatistic(
                  <ClockCircleOutlined style={commonIconStyle} />,
                  "Avg. TMS Time",
                  <Statistic
                    value={activityAvgDetailsState?.avgTmsProcessingTime || 0}
                    suffix="sec"
                    valueStyle={{
                      display: "inline",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  />
                )}
              </Col>
            </MetricCard>
          </Col>
        </Row>
        ) : (
        <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
          <Col xs={24} xl={6}>
            <MetricCard>
              <Row>
                <LabelColCard labelName="Overall Status" />
                <Col span={24}>
                  <Row>
                    <Col span={11}>
                      <Row>
                         <Col span={24}>
                          {CustomStatistic(
                            <CheckCircleOutlined style={commonIconStyle} />,
                            "Total",
                            <Statistic
                              value={activityAvgDetailsState?.success}
                              valueStyle={{
                                display: "inline",
                                color: "#4caf50",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <CheckCircleOutlined style={commonIconStyle} />,
                            "Success",
                            <Statistic
                              value={activityAvgDetailsState?.success}
                              valueStyle={{
                                display: "inline",
                                color: "#4caf50",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <CloseCircleOutlined style={commonIconStyle} />,
                            "Failed",
                            <Statistic
                              value={activityAvgDetailsState?.failed}
                              valueStyle={{
                                display: "inline",
                                color: "#F44336",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                            />
                          )}
                        </Col>
                        <Col span={24}>
                          {CustomStatistic(
                            <CheckCircleOutlined style={commonIconStyle} />,
                            "Success Rate",
                            <Statistic
                              value={
                                !isNaN(overallPodSuccessRate)
                                  ? formatFloatingNumber(overallPodSuccessRate)
                                  : 0
                              }
                              valueStyle={{
                                display: "inline",
                                color: "#4caf50",
                                fontWeight: 600,
                                fontSize: 16,
                              }}
                              suffix="%"
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </MetricCard>
          </Col>
        </Row>
        )}
        <Space
          style={{
            width: "100%",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <Space>
            <span>View By</span>
            <Form.Item label="" name="searchBy" style={{ marginBottom: 0 }}>
              <Radio.Group
                onChange={(e) => onChange(e)}
                optionType="button"
                buttonStyle="solid"
                defaultValue={"CUSTOMERORVENDOR"}
              >
                <Radio.Button value="CUSTOMERORVENDOR">{label}</Radio.Button>
                <Radio.Button value="Date">Date</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Space>
        </Space>
      </Form>
    </DashboardFilterWrapper>
  );
};

export default DashboardFilters;
